package com.macrofocus.eflux.ui

@Suppress("EnumEntryName")
enum class PaletteType {
    light,
    dark
}